
<script>
import { productService,orderService } from "../../services";
import Layout from "../../layouts/main";
import vue2Dropzone from "vue2-dropzone";
import { bannerService } from "../../services";
import { required, requiredIf } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import { routes } from "../../config/api_routes";
import Multiselect from "vue-multiselect";

export default {
  components: {
    orderService,
    Multiselect,
    Layout,
    vueDropzone: vue2Dropzone,DropzonePopup
  },
  data() {
    return {
      value: null,
      tmpBannerImage: "",
      url: null,
      config: config,
      search: "",
      isLoading: false,
      products: [],
      subProducts: [],
      categories: [],
      isDisabled:false,
      bannerTypes: ['Product','Sub Category','Sub Product'],
      banner: {
        id: "",
        name: "",
        image: "",
        product:"",
        sub_product:"",
        category:"",
        status: "",
        banner_type: '',
      },
      banner_type:'',
      // product:'',
      banner_image: "",
      banner_image_path: "",
      banner_image_delete_url: routes.bannerImageDeleteUrl,
      id: "",
    };
  },
  validations: {
    banner: {
      name: {
        required,
      },
      image: {
        required:requiredIf(function (nestedModel) {
          return !(!!this.banner_image || !!this.banner.image)
        })
      },
      product: {
        required : requiredIf(function(form){
            return this.banner.banner_type === 'Product';
        }),
      },
      sub_product: {
        required : requiredIf(function(form){
            return this.banner.banner_type === 'Sub Product';
        }),
      },
      category: {
        required : requiredIf(function(form){
            return this.banner.banner_type === 'Sub Category';
        }),
      }
    },
  },
  mounted() {
    this.getBannerById();
  },
  methods: {
    changeType(type){
      this.banner.products = [];
      this.banner.categories = [];
      this.banner.subProducts = [];
      this.banner.product = "";
    },
    customLabel ({ sub_product_name, material }) {
      if(sub_product_name == "" || sub_product_name == 'undefined') return false;
      return `${sub_product_name} ( ${material} )`
    },
    onBannerImagedeleted(value) {
      this.banner_image = "";
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.banner.image = file;
    },
    getBannerById() {
      bannerService
        .getBannerById({ id: this.$route.params.id })
        .then((response) => {
          const { id, name, status } = response.data.result;
          this.banner_image_path = response.data.result.banner_image_path;
          this.banner_image = response.data.result.image;
          this.id = response.data.result.id;
          this.banner_type = response.data.result.type;

          this.banner.id = response.data.result.id;
          this.banner.name = response.data.result.name;
          this.banner.status = response.data.result.status;
          
          // this.banner = {
          //   id,
          //   name,
          //   status,
          // };
          this.banner.banner_type = response.data.result.type;
          if(response.data.result.product != null){
            if(this.banner_type == 'Product'){
              var selProduct = {id:response.data.result.product.id,item_name:response.data.result.product.item_name};
              this.products.push(selProduct);
              this.banner.product = selProduct;
            }else if(this.banner_type == 'Sub Category'){
              this.categories.push(response.data.result.product);
              this.banner.category = response.data.result.product;
            }else if(this.banner_type == 'Sub Product'){
              this.products.push(response.data.result.product);
              this.banner.product = response.data.result.product;
              this.subProducts.push(response.data.result.sub_product);
              this.banner.sub_product = response.data.result.sub_product;
            }
          }else{
            if(this.banner_type == 'Product'){
              this.banner.product = {id:"",item_name:""};
            }else if(this.banner_type == 'Sub Category'){
              this.banner.category = {id:"",menu_name:""};
            }else if(this.banner_type == 'Sub Product'){
              this.banner.sub_product = {id:"",sub_product_name:"",material:""};
              this.banner.product = {id:"",item_name:""};
            }
          }
        });
    },
    asyncFindProduct(query) {
      this.isLoading = true;
      productService
        .getSearchProduct({ query, id: "", type: "add" })
        .then((response) => {
          // this.products = response.data.result;
          this.products = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
          });
          this.isLoading = false;
        });
    },
    getSubProduct(product) {
      var product_id = product.id;
      if(this.banner.banner_type == 'Product'){
        return false;
      }
      this.subProducts = [];
      this.banner.sub_product = "";
      this.isLoading = true;
      orderService
        .getVariantByProduct({ product_id:product_id,customer_type: "Private"})
        .then((response) => {
          // this.subProducts = response.data.result;
          this.subProducts = response.data.result.sort((a, b) => {
            return a.sub_product_name.localeCompare(b.sub_product_name);
          });
          this.isLoading = false;
        });

    },
    asyncFindCategory(query) {
      this.isLoading = true;
      productService
        .getSearchSubCategory({'search':query})
        .then((response) => {
          // this.categories = response.data.result;
          this.categories = response.data.result.sort((a, b) => {
              return a.menu_name.localeCompare(b.menu_name);
          });
          this.isLoading = false;
        });
    },
    bannerInIt() {
      this.$v.banner.$touch();
      if (this.$v.banner.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 200, function() {
                $(".is-invalid:first").focus();
            });
        },300);
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.banner.id);
        if(!!this.banner.image){
          fd.append("image", this.banner.image);
        }
        fd.append("category_id", this.banner.category.id ?? '');
        fd.append("sub_product_id", this.banner.sub_product.id ?? '');
        fd.append("product_id", this.banner.product.id ?? '');
        fd.append("name", this.banner.name);
        fd.append("status", this.banner.status);
        fd.append("banner_type", this.banner.banner_type);
        bannerService.updateBannerById(fd).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "banner-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <div class="report-tag">
            <h4 class="mb-0 font-size-18">{{ banner.name }}</h4>
            <p><router-link :to="{ name: 'banner-list'}">{{ trans.get('__JSON__.Banners') }}</router-link> > {{ banner.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-12">
          <b-form @submit.prevent="bannerInIt">
            <!-- Banner Info Start -->
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Banner Info') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                  <div class="form-group">
                    <input
                      id="id"
                      name="id"
                      type="hidden"
                      @id="id"
                      v-model="banner.id"
                      class="form-control"
                    />
                  </div>
                  <div class="col-sm-6">
                    <b-form-group id="input-group-1" :label="trans.get('__JSON__.Name')" label-for="name" label-class="required">
                      <b-form-input
                        id="name"
                        name="name"
                        v-model="$v.banner.name.$model"
                        type="text"
                        :placeholder="trans.get('__JSON__.Banner Name Placeholder')"
                        :class="{ 'is-invalid': $v.banner.name.$error }"
                      ></b-form-input>
                      <div v-if="$v.banner.name.$error" class="invalid-feedback">
                        <span v-if="!$v.banner.name.required">{{ trans.get('__JSON__.Banner Name Error') }}.</span>
                      </div>
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                      <div class="form-group">
                        <label class="control-label">{{
                          trans.get("__JSON__.Banner Connect With")
                        }}</label>
                         <multiselect 
                          v-model="banner.banner_type" 
                          id="banner-connect"
                          :options="bannerTypes" 
                          :searchable="false" 
                          :close-on-select="true" 
                          :clear-on-select="true"
                          :show-labels="false" 
                          :multiple="false"
                          :hide-selected="true"
                          @select="changeType"
                          placeholder="Select option">
                        </multiselect>
                    </div>
                  </div>
              
                  <div class="col-sm-6" v-if="this.banner.banner_type == 'Product' || this.banner.banner_type == 'Sub Product'">
                    <div class="form-group">
                      <label class="required" for="product">{{ trans.trans("__JSON__.Product") }}</label>
                      <multiselect
                        v-model="$v.banner.product.$model"
                        id="product"
                        label="item_name"
                        track-by="item_name"
                        :placeholder="trans.get('__JSON__.Type to Search Product')"
                        open-direction="bottom"
                        :options="products"
                        :multiple="false"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="true"
                        :class="{ 'is-invalid': $v.banner.product.$error }"
                        @search-change="asyncFindProduct"
                        @select="getSubProduct"
                        >
                        <span
                        slot="noResult"
                        >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                      </multiselect>
                      <div v-if="$v.banner.product.$error" class="invalid-feedback">
                        <span v-if="!$v.banner.product.required">{{
                          trans.get("__JSON__.Please select product name")
                        }}</span>
                      </div>
                    </div>
                  </div>

                    <div class="col-sm-6" v-if="this.banner.banner_type == 'Sub Product'">
                  <div class="form-group">
                    <label class="required">{{ trans.trans("__JSON__.Sub Product") }}</label>
                    <multiselect
                      v-model="$v.banner.sub_product.$model"
                      id="sub_product"
                      label="sub_product_name"
                      track-by="id"
                      :placeholder="trans.get('__JSON__.Sub Product')"
                      open-direction="bottom"
                      :options="subProducts"
                      :multiple="false"
                      :searchable="false"
                      :loading="isLoading"
                      :internal-search="false"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      :custom-label="customLabel"
                      :class="{ 'is-invalid': $v.banner.sub_product.$error }"
                      >
                      <span
                      slot="noResult"
                      >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                    </multiselect>
                    <div v-if="$v.banner.sub_product.$error" class="invalid-feedback">
                      <span v-if="!$v.banner.sub_product.required">{{
                        trans.get("__JSON__.Please select SubProduct")
                      }}</span>
                    </div>
                  </div>
                </div>

                  <div class="col-sm-6" v-if="this.banner.banner_type == 'Sub Category'">
                    <div class="form-group">
                      <label class="required">{{ trans.trans("__JSON__.Sub Category") }}</label>
                      <multiselect
                        v-model="$v.banner.category.$model"
                        id="category"
                        label="menu_name"
                        track-by="menu_name"
                        :placeholder="trans.get('__JSON__.Sub Category')"
                        open-direction="bottom"
                        :options="categories"
                        :multiple="false"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="true"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        :class="{ 'is-invalid': $v.banner.category.$error }"
                        @search-change="asyncFindCategory"
                        >
                        <span
                        slot="noResult"
                        >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                      </multiselect>
                      <div v-if="$v.banner.category.$error" class="invalid-feedback">
                        <span v-if="!$v.banner.category.required">{{
                          trans.get("__JSON__.Select Sub Category")
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 vendor-status">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Status')"
                      label-for="status"
                    >
                      <label class="switch">
                        <input
                          type="checkbox"
                          id="togBtn"
                          name="status"
                          v-model="banner.status"
                          class="switch-on"
                          true-value="1"
                          false-value="0"
                        />
                        <div class="slider round">
                          <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                          <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                        </div>
                      </label>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
            <!-- Banner Info End -->

            <!-- Banner Image Start -->
            <div class="card">
              <div class="card-body">
                <h4 class="card-title required">{{ trans.get('__JSON__.Banner Image') }}</h4>
                <p class="card-title-desc"></p>

                <div class="row">
                  <div class="col-sm-3">
                    <dropzone-popup
                      v-model="banner.image"
                      id="banner_image"
                      acceptedFiles=".jpeg,.jpg,.png"
                      :editable-images="banner_image"
                      :media-path="banner_image_path+'/thumb'"
                      :delete-path="banner_image_delete_url"
                      @image-deleted="this.onBannerImagedeleted"
                      :class="{ 'is-invalid': $v.banner.image.$error }"
                    />
                    <div v-if="$v.banner.image.$error" class="invalid-feedback cuisine-img">
                      <span
                        v-if="!$v.banner.image.required"
                      >{{ trans.get('__JSON__.Banner Image Error') }}.</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update Banner') }}</button>
                    <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                    <router-link
                      :to="{name:'banner-list'}"
                    >
                      <b-button
                        type="button" 
                        variant="secondary" 
                        class="mt-3">
                        {{ trans.get('__JSON__.Cancel') }}
                      </b-button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <!-- Banner Image End -->
          </b-form>
        </div>
    </div>
  </Layout>
</template>

<style>
</style>